<template>
  <div class="container-fluid">
    <div class="mt-3 mb1 px-4">
      <b-button :to="{ name: 'AdminHome' }" variant="success">
        Volver a home de admin
      </b-button>
    </div>
    <b-row class="mt-5 mb-1 px-4">
      <b-col class="text-center text-white" cols="12">
        <h1>Adjudicaciones Mercado Público</h1>
        <p class="mt-2">
          Ingreso manual de órdenes de compra adjudicadas. Aparecen también en el
          calendario de reservas (en amarillo) según su rango check-in / check-out.
          Es solo seguimiento interno: no afecta la disponibilidad del sitio público.
        </p>
      </b-col>
    </b-row>

    <!-- FORMULARIO INGRESO / EDICION -->
    <b-row class="px-4">
      <b-col cols="12">
        <b-card
          :header="editandoId ? 'Editar adjudicación' : 'Nueva adjudicación'"
          header-bg-variant="dark"
          header-text-variant="white"
          class="mb-4"
        >
          <b-form @submit.prevent="guardar">
            <b-row>
              <b-col cols="12" md="4">
                <b-form-group label="Fecha de adjudicación *" label-for="fechaAdjudicacion">
                  <b-form-input
                    id="fechaAdjudicacion"
                    v-model="form.fechaAdjudicacion"
                    type="date"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group label="ID Orden de Compra *" label-for="idOC">
                  <b-form-input
                    id="idOC"
                    v-model.trim="form.idOC"
                    type="text"
                    placeholder="Ej: 1509-122-SE25"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="4">
                <b-form-group label="Monto adjudicado (CLP) *" label-for="montoAdjudicado">
                  <b-form-input
                    id="montoAdjudicado"
                    v-model.number="form.montoAdjudicado"
                    type="number"
                    min="0"
                    step="1"
                    placeholder="Ej: 1850000"
                    required
                  ></b-form-input>
                  <small class="text-muted">{{ montoFormateado }}</small>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <b-form-group label="Institución *" label-for="institucion">
                  <b-form-input
                    id="institucion"
                    v-model.trim="form.institucion"
                    type="text"
                    placeholder="Ej: Municipalidad de ..."
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Proveedor *" label-for="proveedor">
                  <b-form-input
                    id="proveedor"
                    v-model.trim="form.proveedor"
                    type="text"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <b-form-group label="Descripción *" label-for="descripcion">
                  <b-form-textarea
                    id="descripcion"
                    v-model.trim="form.descripcion"
                    rows="3"
                    max-rows="8"
                    placeholder="Descripción del servicio adjudicado..."
                    required
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" md="6">
                <b-form-group label="Fecha check-in *" label-for="checkIn">
                  <b-form-input
                    id="checkIn"
                    v-model="form.checkIn"
                    type="date"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group label="Fecha check-out *" label-for="checkOut">
                  <b-form-input
                    id="checkOut"
                    v-model="form.checkOut"
                    type="date"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-alert :show="!!errorFechas" variant="danger" class="py-2">
              {{ errorFechas }}
            </b-alert>

            <div class="d-flex">
              <b-button type="submit" variant="primary" :disabled="guardando">
                <b-spinner v-if="guardando" small></b-spinner>
                {{ editandoId ? "Actualizar adjudicación" : "Guardar adjudicación" }}
              </b-button>
              <b-button
                v-if="editandoId"
                type="button"
                variant="outline-secondary"
                class="ml-2"
                @click="cancelarEdicion"
              >
                Cancelar edición
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <!-- TABLA -->
    <b-row class="px-4 pb-5">
      <b-col cols="12">
        <b-row>
          <b-col cols="12" class="my-2">
            <b-form-group
              label="Filtrar por palabra"
              label-cols-sm="6"
              label-align-sm="right"
              label-size="md"
              label-for="filterInput"
              class="mb-1 text-white"
            >
              <b-input-group size="md">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  class="w-100"
                  placeholder="Ingresa un término (institución, ID OC, proveedor)..."
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <div v-if="loading" class="text-center text-white py-4">
          <b-spinner small></b-spinner>
          Cargando adjudicaciones...
        </div>
        <b-table
          v-else
          show-empty
          :fields="campos"
          :items="adjudicacionesTabla"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="['institucion', 'idOC', 'proveedor', 'descripcion']"
          empty-text="Aún no hay adjudicaciones cargadas."
          empty-filtered-text="Sin registros que coincidan con la búsqueda..."
          head-variant="dark"
          table-variant="light"
          striped
          hover
          @filtered="onFiltered"
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(descripcion)="data">
            {{ truncar(data.item.descripcion, 60) }}
          </template>
          <template v-slot:cell(montoAdjudicado)="data">
            {{ formatearCLP(data.item.montoAdjudicado) }}
          </template>
          <template v-slot:cell(acciones)="data">
            <div class="container-fluid">
              <b-row>
                <b-col class="text-center">
                  <b-icon
                    class="iconHover"
                    icon="card-text"
                    variant="info"
                    font-scale="1.5"
                    @click="data.toggleDetails"
                    title="Ver/ocultar detalles"
                  />
                </b-col>
                <b-col class="text-center">
                  <b-icon
                    class="iconHover"
                    icon="pencil-fill"
                    variant="primary"
                    font-scale="1.4"
                    @click="editar(data.item._raw)"
                    title="Editar"
                  />
                </b-col>
                <b-col class="text-center">
                  <b-icon
                    class="iconHover"
                    icon="trash-fill"
                    variant="danger"
                    font-scale="1.4"
                    @click="eliminar(data.item._raw)"
                    title="Eliminar"
                  />
                </b-col>
              </b-row>
            </div>
          </template>
          <template v-slot:row-details="data">
            <b-card class="ml-2 pl-4 pt-2">
              <ul style="line-height: 2">
                <li><strong>ID Orden de Compra:</strong> {{ data.item.idOC }}</li>
                <li><strong>Institución:</strong> {{ data.item.institucion }}</li>
                <li><strong>Proveedor:</strong> {{ data.item.proveedor }}</li>
                <li><strong>Descripción:</strong> {{ data.item.descripcion }}</li>
                <li>
                  <strong>Fecha de adjudicación:</strong>
                  {{ data.item.fechaAdjudicacion }}
                </li>
                <li>
                  <strong>Rango del servicio:</strong>
                  {{ data.item.checkIn }} → {{ data.item.checkOut }}
                </li>
                <li>
                  <strong>Monto adjudicado:</strong>
                  {{ formatearCLP(data.item.montoAdjudicado) }}
                </li>
              </ul>
            </b-card>
          </template>
        </b-table>
        <b-row>
          <b-col cols="12" class="my-0">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="fill"
              size="md"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase, { db } from "../../firebase.service";

const RAZON_SOCIAL_DEFAULT = "Surreal Travel SpA";

function formItem() {
  return {
    fechaAdjudicacion: "",
    idOC: "",
    descripcion: "",
    institucion: "",
    proveedor: RAZON_SOCIAL_DEFAULT,
    checkIn: "",
    checkOut: "",
    montoAdjudicado: null
  };
}

export default {
  name: "Adjudicaciones",
  metaInfo: {
    title: "Adjudicaciones Mercado Público"
  },
  data() {
    return {
      adjudicaciones: [],
      loading: true,
      guardando: false,
      editandoId: null,
      form: formItem(),
      filter: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 7,
      sortBy: "checkIn",
      sortDesc: true,
      sortDirection: "desc",
      campos: [
        { key: "index", label: "N°" },
        { key: "fechaAdjudicacion", label: "F. Adjudicación", sortable: true, class: "text-center" },
        { key: "idOC", label: "ID OC", sortable: true, class: "text-center" },
        { key: "institucion", label: "Institución", sortable: true, class: "text-center" },
        { key: "descripcion", label: "Descripción", class: "text-center" },
        { key: "proveedor", label: "Proveedor", sortable: true, class: "text-center" },
        { key: "checkIn", label: "Check-in", sortable: true, class: "text-center" },
        { key: "checkOut", label: "Check-out", sortable: true, class: "text-center" },
        { key: "montoAdjudicado", label: "Monto", sortable: true, class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" }
      ]
    };
  },
  created() {
    this.cargarAdjudicaciones();
  },
  computed: {
    montoFormateado() {
      if (this.form.montoAdjudicado === null || this.form.montoAdjudicado === "") return "";
      return this.formatearCLP(this.form.montoAdjudicado);
    },
    errorFechas() {
      if (!this.form.checkIn || !this.form.checkOut) return "";
      if (this.form.checkOut < this.form.checkIn) {
        return "La fecha de check-out no puede ser anterior al check-in.";
      }
      return "";
    },
    adjudicacionesTabla() {
      return (this.adjudicaciones || []).map(a => ({
        id: a.id,
        fechaAdjudicacion: a.fechaAdjudicacion || "-",
        idOC: a.idOC || "-",
        institucion: a.institucion || "-",
        descripcion: a.descripcion || "",
        proveedor: a.proveedor || "-",
        checkIn: a.checkIn || "-",
        checkOut: a.checkOut || "-",
        montoAdjudicado: typeof a.montoAdjudicado === "number" ? a.montoAdjudicado : Number(a.montoAdjudicado) || 0,
        _raw: a
      }));
    }
  },
  methods: {
    cargarAdjudicaciones() {
      this.loading = true;
      this.unsubscribe = db.collection("adjudicaciones").onSnapshot(
        snapshot => {
          const arr = [];
          snapshot.forEach(doc => {
            arr.push({ id: doc.id, ...doc.data() });
          });
          this.adjudicaciones = arr;
          this.totalRows = arr.length;
          this.loading = false;
        },
        err => {
          console.log("Error al cargar adjudicaciones:", err);
          this.loading = false;
        }
      );
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatearCLP(valor) {
      const n = Number(valor);
      if (!Number.isFinite(n)) return "-";
      return "$ " + String(Math.round(n)).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " CLP";
    },
    truncar(texto, max) {
      const t = (texto || "").toString();
      return t.length > max ? t.slice(0, max) + "…" : t;
    },
    validar() {
      const f = this.form;
      if (!f.fechaAdjudicacion || !f.idOC || !f.descripcion || !f.institucion || !f.proveedor || !f.checkIn || !f.checkOut) {
        this.$bvToast.toast("Completa todos los campos obligatorios.", {
          title: "Faltan datos", variant: "warning", solid: true, toaster: "b-toaster-top-center"
        });
        return false;
      }
      if (this.errorFechas) {
        this.$bvToast.toast(this.errorFechas, {
          title: "Fechas inválidas", variant: "danger", solid: true, toaster: "b-toaster-top-center"
        });
        return false;
      }
      const monto = Number(f.montoAdjudicado);
      if (!Number.isFinite(monto) || monto < 0) {
        this.$bvToast.toast("El monto debe ser un número ≥ 0.", {
          title: "Monto inválido", variant: "danger", solid: true, toaster: "b-toaster-top-center"
        });
        return false;
      }
      return true;
    },
    async guardar() {
      if (this.guardando) return;
      if (!this.validar()) return;
      this.guardando = true;

      const payload = {
        fechaAdjudicacion: this.form.fechaAdjudicacion,
        idOC: this.form.idOC,
        descripcion: this.form.descripcion,
        institucion: this.form.institucion,
        proveedor: this.form.proveedor,
        checkIn: this.form.checkIn,
        checkOut: this.form.checkOut,
        montoAdjudicado: Number(this.form.montoAdjudicado),
        updatedAt: firebase.firestore.FieldValue.serverTimestamp()
      };

      try {
        if (this.editandoId) {
          await db.collection("adjudicaciones").doc(this.editandoId).update(payload);
          this.$bvToast.toast("Adjudicación actualizada.", {
            title: "Listo", variant: "success", solid: true, toaster: "b-toaster-top-center"
          });
        } else {
          payload.createdAt = firebase.firestore.FieldValue.serverTimestamp();
          await db.collection("adjudicaciones").add(payload);
          this.$bvToast.toast("Adjudicación guardada.", {
            title: "Listo", variant: "success", solid: true, toaster: "b-toaster-top-center"
          });
        }
        this.cancelarEdicion();
      } catch (error) {
        console.log("Error al guardar adjudicación:", error);
        this.$bvToast.toast("Error al guardar. Revisa la consola.", {
          title: "Error", variant: "danger", solid: true, toaster: "b-toaster-top-center"
        });
      } finally {
        this.guardando = false;
      }
    },
    editar(raw) {
      this.editandoId = raw.id;
      this.form = {
        fechaAdjudicacion: raw.fechaAdjudicacion || "",
        idOC: raw.idOC || "",
        descripcion: raw.descripcion || "",
        institucion: raw.institucion || "",
        proveedor: raw.proveedor || RAZON_SOCIAL_DEFAULT,
        checkIn: raw.checkIn || "",
        checkOut: raw.checkOut || "",
        montoAdjudicado: typeof raw.montoAdjudicado === "number" ? raw.montoAdjudicado : Number(raw.montoAdjudicado) || null
      };
      if (typeof window !== "undefined" && window.scrollTo) window.scrollTo(0, 0);
    },
    cancelarEdicion() {
      this.editandoId = null;
      this.form = formItem();
    },
    async eliminar(raw) {
      const ok = window.confirm(
        "¿Eliminar la adjudicación " + (raw.idOC || "") + " (" + (raw.institucion || "") + ")?\n\n" +
        "Desaparecerá de la tabla y del calendario. Esta acción no se puede deshacer."
      );
      if (!ok) return;
      try {
        await db.collection("adjudicaciones").doc(raw.id).delete();
        if (this.editandoId === raw.id) this.cancelarEdicion();
        this.$bvToast.toast("Adjudicación eliminada.", {
          title: "Listo", variant: "success", solid: true, toaster: "b-toaster-top-center"
        });
      } catch (error) {
        console.log("Error al eliminar adjudicación:", error);
        this.$bvToast.toast("Error al eliminar. Revisa la consola.", {
          title: "Error", variant: "danger", solid: true, toaster: "b-toaster-top-center"
        });
      }
    }
  },
  beforeDestroy() {
    if (typeof this.unsubscribe === "function") {
      this.unsubscribe();
    }
  }
};
</script>

<style>
.iconHover:hover {
  cursor: pointer;
}
</style>
